var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    {
      staticClass: "boss-center",
      class: { "notice-background": !_vm.isMessageReplied },
      attrs: { "data-test": "message-td" },
    },
    [
      _c(
        _vm.componentTag,
        _vm._g(
          _vm._b(
            { tag: "Component", attrs: { "data-test": "message-link" } },
            "Component",
            _vm.additionalProps,
            false
          ),
          _vm.additionalListeners
        ),
        [
          _vm.isEntryMessageReservationReserved
            ? _c(
                "span",
                { attrs: { "data-test": "entry-message-reservation" } },
                [_vm._v("予約中"), _c("br")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMessageReplied
            ? _c("span", { attrs: { "data-test": "replied" } }, [
                _vm._v("返信済み"),
                _c("br"),
              ])
            : _c(
                "span",
                {
                  staticClass: "boss-notice-text",
                  attrs: { "data-test": "no-replied" },
                },
                [_vm._v("未返信"), _c("br")]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "boss-layout boss-layout-vertical boss-layout-gap-small",
            },
            [
              _vm.receivedMessageCount
                ? _c("div", { attrs: { "data-test": "icon-wrap" } }, [
                    !_vm.isMessageRead
                      ? _c("img", {
                          attrs: {
                            "data-test": "close-icon",
                            src: require("@/assets/images/dm-close.svg"),
                          },
                        })
                      : _vm.isMessageRead && _vm.isMessageReplied
                      ? _c("img", {
                          attrs: {
                            "data-test": "open-icon-inactive",
                            src: require("@/assets/images/dm-open-gray.svg"),
                          },
                        })
                      : _vm.isMessageRead && !_vm.isMessageReplied
                      ? _c("img", {
                          attrs: {
                            "data-test": "open-icon-active",
                            src: require("@/assets/images/dm-open-red.svg"),
                          },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { attrs: { "data-test": "received-count" } }, [
                _vm._v("受信数(" + _vm._s(_vm.receivedMessageCount) + ")"),
              ]),
              _vm._v(" "),
              _c("span", { attrs: { "data-test": "latest-message" } }, [
                _vm._v(_vm._s(_vm.latestMessage)),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }